import http from '../api/http'
import { setGlobalAppNotification, setLoading, setGlobalSyncInProgress } from "./app-actions";
import { systemSettingsActions } from "../slices/settings-slice";
import qs from 'qs';

export const getSystemSettings = () => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.get(`${REACT_APP_SYSTEM_SETTINGS}`);
    return (dispatch) => {
        res.then(({ data }) => {
            if (data?.data.length >= 0) {
                delete data.data[0].createdAt;
                delete data.data[0].updatedAt;
                delete data.data[0].__v;
                dispatch(systemSettingsActions.getSystemSettings(data.data[0]));
                dispatch(setLoading(false))
            }
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error getting system settings!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const updateSystemSettings = (id, objParams, callback) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.patch(`${REACT_APP_SYSTEM_SETTINGS}/${id}`, objParams);
    return (dispatch) => {
        dispatch(setLoading(true))
        dispatch(clear())
        res.then(({ data }) => {
            // try {

            if (typeof callback === 'function') {
                callback(data)
            }
            dispatch(setGlobalAppNotification("System Settings Updated!", 'success'))
            dispatch(systemSettingsActions.updateSystemSettings(data))
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error update system settings!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const getLeadFields = () => {
    const { REACT_APP_LEAD_FIELDS } = process.env
    const res = http.get(`${REACT_APP_LEAD_FIELDS}`);
    return (dispatch) => {
        res.then(({ data }) => {
            if (data?.data.length >= 0) {
                delete data.data[0].createdAt;
                delete data.data[0].updatedAt;
                delete data.data[0].__v;
                dispatch(systemSettingsActions.getLeadFields(data.data[0]));
                dispatch(setLoading(false))
            }
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error getting lead fields!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const updateLeadFields = (id, objParams, callback) => {
    const { REACT_APP_LEAD_FIELDS } = process.env
    const res = http.patch(`${REACT_APP_LEAD_FIELDS}/${id}`, objParams);
    return (dispatch) => {
        dispatch(setLoading(true))
        res.then(({ data }) => {
            // try {
            if (typeof callback === 'function') {
                callback(data)
            }
            dispatch(setGlobalAppNotification("Lead Fields Updated!", 'success'))
            dispatch(systemSettingsActions.updateLeadFields(data))
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error updating lead fields!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const deleteLeadFields = (id, objParams, callback) => {
    const { REACT_APP_LEAD_FIELDS } = process.env
    const res = http.delete(`${REACT_APP_LEAD_FIELDS}/${id}?${qs.stringify(objParams, { encode: false })}`);
    return (dispatch) => {
        dispatch(setLoading(true))
        res.then(({ data }) => {
            // try {
            if (typeof callback === 'function') {
                callback(data)
            }
            dispatch(setGlobalAppNotification("Lead Field Deleted!", 'success'))
            dispatch(systemSettingsActions.updateLeadFields(data))
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error updating lead fields!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const getAdminDashboard = (objParams) => {
    const { REACT_APP_ADMIN_DASHBOARD } = process.env
    const res = http.get(`${REACT_APP_ADMIN_DASHBOARD}`, { params: objParams });
    return (dispatch) => {
        res.then(({ data }) => {
            if (data?.data.length >= 0) {
                dispatch(systemSettingsActions.getAdminDashboard(data.data[0]));
                dispatch(setLoading(false))
            }
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error Getting Dashboard Data!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const getDealFields = () => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.get(`${REACT_APP_SYSTEM_SETTINGS}/dealsfields`);
    return (dispatch) => {
        res.then(({ data }) => {
            if (data?.data.length >= 0) {
                delete data.data[0].__v;
                dispatch(systemSettingsActions.getDealFields(data.data[0]));
                dispatch(setLoading(false))
            }
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error getting deal fields!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const updateDealFields = (id, objParams, callback) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.patch(`${REACT_APP_SYSTEM_SETTINGS}/dealsfields/${id}`, objParams);
    return (dispatch) => {
        dispatch(setLoading(true))
        res.then(({ data }) => {
            // try {
            if (typeof callback === 'function') {
                callback(data)
            }
            dispatch(setGlobalAppNotification("Deal Fields Updated!", 'success'))
            dispatch(systemSettingsActions.updateDealFields(data))
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error updating deal fields!", 'error'))
            dispatch(setLoading(false))
        })
    }
};


export const deleteDealFields = (id, objParams, callback) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.delete(`${REACT_APP_SYSTEM_SETTINGS}/dealsfields/${id}?${qs.stringify(objParams, { encode: false })}`);
    return (dispatch) => {
        dispatch(setLoading(true))
        res.then(({ data }) => {
            // try {
            if (typeof callback === 'function') {
                callback(data)
            }
            dispatch(setGlobalAppNotification("Deal Field Deleted!", 'success'))
            dispatch(systemSettingsActions.updateDealFields(data))
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error updating deal fields!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const synchronizeRecords = (callback) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.post(`${REACT_APP_SYSTEM_SETTINGS}/pullzohorecords`);
    return (dispatch) => {
        dispatch(setLoading(true))
        dispatch(setGlobalSyncInProgress(true))
        dispatch(clear())
        res.then(({ data }) => {
            if (typeof callback === 'function') {
                callback(data)
            }
            dispatch(setGlobalAppNotification(data?.message + ` Record Updates. Leads:${data.updates.leads} and Cases:${data.updates.cases}`, 'success'))
            dispatch(systemSettingsActions.globalSynced(data))
            dispatch(setLoading(false))
            dispatch(setGlobalSyncInProgress(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error update system settings!", 'error'))
            dispatch(setLoading(false))
            dispatch(setGlobalSyncInProgress(false))
        })
    }
};

export const globalRecordSearch = (objParams) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.post(`${REACT_APP_SYSTEM_SETTINGS}/globalSearch`, {...objParams});
    return (dispatch) => {
        dispatch(setLoading(true))
        dispatch(setGlobalSyncInProgress(true))
        dispatch(clear())
        res.then(({ data }) => {
            if (data?.success) {
                dispatch(systemSettingsActions.globalRecordSearch(data));
                dispatch(setLoading(false))
                dispatch(setGlobalSyncInProgress(false))
            }
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error getting deal fields!", 'error'))
            dispatch(setLoading(false))
            dispatch(setGlobalSyncInProgress(false))
        })
    }
};

export const fetchSystemNotifications = (objParams) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.get(`${REACT_APP_SYSTEM_SETTINGS}/getNotifications`,{ params: objParams });
    return (dispatch) => {
        res.then(({ data }) => {
            dispatch(systemSettingsActions.fetchSystemNotifications(data));
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error getting system notification!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const updateSystemNotificationsDetails = (id, objParams) => {
    const { REACT_APP_SYSTEM_NOTIFICATION } = process.env
    const res = http.patch(`${REACT_APP_SYSTEM_NOTIFICATION}/${id}`, objParams);
    return (dispatch) => {
        dispatch(setLoading(true))
        dispatch(clear())
        res.then(({ data }) => {
            dispatch(systemSettingsActions.updateSystemNotificationsDetails(data))
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error update system notification!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const fetchSystemAnnouncements = (objParams) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.get(`${REACT_APP_SYSTEM_SETTINGS}/getNotifications`,{ params: objParams });
    return (dispatch) => {
        res.then(({ data }) => {
            dispatch(systemSettingsActions.fetchSystemAnnoucements(data));
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error getting system notification!", 'error'))
            dispatch(setLoading(false))
        })
    }
};

export const updateSystemNotifications = (notifications) => {
    return (dispatch) => {
        dispatch(systemSettingsActions.updateSystemNotifications(notifications))
    }
}

export const setUsersSystemNotifications = (notifications) => {
    return (dispatch) => {
        dispatch(systemSettingsActions.setUsersSystemNotifications(notifications))
    }
}

export const markAllNotificationAsRead = (objParams) => {
    const { REACT_APP_SYSTEM_SETTINGS } = process.env
    const res = http.put(`${REACT_APP_SYSTEM_SETTINGS}/markAllNotificationAsRead`, {...objParams});
    return (dispatch) => {
        dispatch(setLoading(true))
        dispatch(clear())
        res.then(({ data }) => {
            dispatch(systemSettingsActions.updateSystemNotificationsDetails(data))
            dispatch(setLoading(false))
        }).catch(error => {
            dispatch(setGlobalAppNotification(error?.response?.data?.message || error?.messages || "Error update system notification!", 'error'))
            dispatch(setLoading(false))
        })
    }
}

export const clear = () => {
    return (dispatch) => {
        dispatch(systemSettingsActions.reset())
    }
}
